import React from 'react';
import { getStatusColor } from '../../utils/helpers';

interface StatusChipProps {
  status: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function StatusChip({
  status,
  label,
  size = 'md',
}: StatusChipProps) {
  if (!status) return null;

  const colorClass = getStatusColor(status);

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[10px] font-semibold rounded-full',
    md: 'px-2.5 py-0.5 text-xs font-semibold rounded-full',
    lg: 'px-3 py-1 text-xs font-bold tracking-wide uppercase rounded-full',
  };

  const displayText = label ?? status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <span
      className={`inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors ${sizeClasses[size]} ${colorClass}`}
    >
      {displayText}
    </span>
  );
}
